import { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router";

import { BigScreenLogin } from "./big-screen";

import { verifyCredentials } from "context/auth";
import { setReferrerURL } from "utils/page-sense-events";

const Login: React.FC = (): JSX.Element => {
  const referrerURL = document.referrer;
  setReferrerURL(referrerURL);

  const navigate = useNavigate();

  useEffect((): void => {
    async function verify(): Promise<void> {
      const verified = await verifyCredentials();
      if (verified) void navigate("/home");
    }

    void verify();
  }, [navigate]);

  return (
    <Fragment>
      <Helmet>
        <title>{"Login | Fluid Attacks"}</title>
        <meta
          content={
            "Log in to Fluid Attacks to access your Attack Resistance Management platform and manage your organization's vulnerabilities in one place."
          }
          name={"description"}
        />
        <link href={"https://app.fluidattacks.com/"} rel={"canonical"} />
      </Helmet>
      <BigScreenLogin />
    </Fragment>
  );
};

export { Login };
